function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/* global DOMParser */

/**
 * @module widget/widgettypearound
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import Template from '@ckeditor/ckeditor5-ui/src/template';
import Enter from '@ckeditor/ckeditor5-enter/src/enter';
import Delete from '@ckeditor/ckeditor5-typing/src/delete';
import { isForwardArrowKeyCode, keyCodes } from '@ckeditor/ckeditor5-utils/src/keyboard';
import { isTypeAroundWidget, getClosestTypeAroundDomButton, getTypeAroundButtonPosition, getClosestWidgetViewElement, getTypeAroundFakeCaretPosition, TYPE_AROUND_SELECTION_ATTRIBUTE } from './utils';
import { isNonTypingKeystroke } from '@ckeditor/ckeditor5-typing/src/utils/injectunsafekeystrokeshandling';
import { isWidget } from '../utils';
import returnIcon from '../../theme/icons/return-arrow.svg';
import '../../theme/widgettypearound.css';
var POSSIBLE_INSERTION_POSITIONS = ['before', 'after']; // Do the SVG parsing once and then clone the result <svg> DOM element for each new button.

var RETURN_ARROW_ICON_ELEMENT = new DOMParser().parseFromString(returnIcon, 'image/svg+xml').firstChild;
var PLUGIN_DISABLED_EDITING_ROOT_CLASS = 'ck-widget__type-around_disabled';
/**
 * A plugin that allows users to type around widgets where normally it is impossible to place the caret due
 * to limitations of web browsers. These "tight spots" occur, for instance, before (or after) a widget being
 * the first (or last) child of its parent or between two block widgets.
 *
 * This plugin extends the {@link module:widget/widget~Widget `Widget`} plugin and injects the user interface
 * with two buttons into each widget instance in the editor. Each of the buttons can be clicked by the
 * user if the widget is next to the "tight spot". Once clicked, a paragraph is created with the selection anchored
 * in it so that users can type (or insert content, paste, etc.) straight away.
 *
 * @extends module:core/plugin~Plugin
 */

var WidgetTypeAround = /*#__PURE__*/function (_Plugin) {
  _inherits(WidgetTypeAround, _Plugin);

  var _super = _createSuper(WidgetTypeAround);

  /**
   * @inheritDoc
   */
  function WidgetTypeAround(editor) {
    var _this;

    _classCallCheck(this, WidgetTypeAround);

    _this = _super.call(this, editor);
    /**
     * A reference to the model widget element that has the fake caret active
     * on either side of it. It is later used to remove CSS classes associated with the fake caret
     * when the widget no longer needs it.
     *
     * @private
     * @member {module:engine/model/element~Element|null}
     */

    _this._currentFakeCaretModelElement = null;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(WidgetTypeAround, [{
    key: "init",
    value: function init() {
      var editor = this.editor;
      var editingView = editor.editing.view; // Set a CSS class on the view editing root when the plugin is disabled so all the buttons
      // and lines visually disappear. All the interactions are disabled in individual plugin methods.

      this.on('change:isEnabled', function (evt, data, isEnabled) {
        editingView.change(function (writer) {
          var _iterator = _createForOfIteratorHelper(editingView.document.roots),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var root = _step.value;

              if (isEnabled) {
                writer.removeClass(PLUGIN_DISABLED_EDITING_ROOT_CLASS, root);
              } else {
                writer.addClass(PLUGIN_DISABLED_EDITING_ROOT_CLASS, root);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        });

        if (!isEnabled) {
          editor.model.change(function (writer) {
            writer.removeSelectionAttribute(TYPE_AROUND_SELECTION_ATTRIBUTE);
          });
        }
      });

      this._enableTypeAroundUIInjection();

      this._enableInsertingParagraphsOnButtonClick();

      this._enableInsertingParagraphsOnEnterKeypress();

      this._enableInsertingParagraphsOnTypingKeystroke();

      this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows();

      this._enableDeleteIntegration();

      this._enableInsertContentIntegration();

      this._enableDeleteContentIntegration();
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this._currentFakeCaretModelElement = null;
    }
    /**
     * Inserts a new paragraph next to a widget element with the selection anchored in it.
     *
     * **Note**: This method is heavily user-oriented and will both focus the editing view and scroll
     * the viewport to the selection in the inserted paragraph.
     *
     * @protected
     * @param {module:engine/model/element~Element} widgetModelElement The model widget element next to which a paragraph is inserted.
     * @param {'before'|'after'} position The position where the paragraph is inserted. Either `'before'` or `'after'` the widget.
     */

  }, {
    key: "_insertParagraph",
    value: function _insertParagraph(widgetModelElement, position) {
      var editor = this.editor;
      var editingView = editor.editing.view;
      editor.execute('insertParagraph', {
        position: editor.model.createPositionAt(widgetModelElement, position)
      });
      editingView.focus();
      editingView.scrollToTheSelection();
    }
    /**
     * A wrapper for the {@link module:utils/emittermixin~EmitterMixin#listenTo} method that executes the callbacks only
     * when the plugin {@link #isEnabled is enabled}.
     *
     * @private
     * @param {module:utils/emittermixin~Emitter} emitter The object that fires the event.
     * @param {String} event The name of the event.
     * @param {Function} callback The function to be called on event.
     * @param {Object} [options={}] Additional options.
     * @param {module:utils/priorities~PriorityString|Number} [options.priority='normal'] The priority of this event callback. The higher
     * the priority value the sooner the callback will be fired. Events having the same priority are called in the
     * order they were added.
     */

  }, {
    key: "_listenToIfEnabled",
    value: function _listenToIfEnabled(emitter, event, callback, options) {
      var _this2 = this;

      this.listenTo(emitter, event, function () {
        // Do not respond if the plugin is disabled.
        if (_this2.isEnabled) {
          callback.apply(void 0, arguments);
        }
      }, options);
    }
    /**
     * Similar to {@link #_insertParagraph}, this method inserts a paragraph except that it
     * does not expect a position. Instead, it performs the insertion next to a selected widget
     * according to the `widget-type-around` model selection attribute value (fake caret position).
     *
     * Because this method requires the `widget-type-around` attribute to be set,
     * the insertion can only happen when the widget's fake caret is active (e.g. activated
     * using the keyboard).
     *
     * @private
     * @returns {Boolean} Returns `true` when the paragraph was inserted (the attribute was present) and `false` otherwise.
     */

  }, {
    key: "_insertParagraphAccordingToFakeCaretPosition",
    value: function _insertParagraphAccordingToFakeCaretPosition() {
      var editor = this.editor;
      var model = editor.model;
      var modelSelection = model.document.selection;
      var typeAroundFakeCaretPosition = getTypeAroundFakeCaretPosition(modelSelection);

      if (!typeAroundFakeCaretPosition) {
        return false;
      }

      var selectedModelElement = modelSelection.getSelectedElement();

      this._insertParagraph(selectedModelElement, typeAroundFakeCaretPosition);

      return true;
    }
    /**
     * Creates a listener in the editing conversion pipeline that injects the widget type around
     * UI into every single widget instance created in the editor.
     *
     * The UI is delivered as a {@link module:engine/view/uielement~UIElement}
     * wrapper which renders DOM buttons that users can use to insert paragraphs.
     *
     * @private
     */

  }, {
    key: "_enableTypeAroundUIInjection",
    value: function _enableTypeAroundUIInjection() {
      var editor = this.editor;
      var schema = editor.model.schema;
      var t = editor.locale.t;
      var buttonTitles = {
        before: t('Insert paragraph before block'),
        after: t('Insert paragraph after block')
      };
      editor.editing.downcastDispatcher.on('insert', function (evt, data, conversionApi) {
        var viewElement = conversionApi.mapper.toViewElement(data.item); // Filter out non-widgets and inline widgets.

        if (isTypeAroundWidget(viewElement, data.item, schema)) {
          injectUIIntoWidget(conversionApi.writer, buttonTitles, viewElement);
        }
      }, {
        priority: 'low'
      });
    }
    /**
     * Brings support for the fake caret that appears when either:
     *
     * * the selection moves to a widget from a position next to it using arrow keys,
     * * the arrow key is pressed when the widget is already selected.
     *
     * The fake caret lets the user know that they can start typing or just press
     * <kbd>Enter</kbd> to insert a paragraph at the position next to a widget as suggested by the fake caret.
     *
     * The fake caret disappears when the user changes the selection or the editor
     * gets blurred.
     *
     * The whole idea is as follows:
     *
     * 1. A user does one of the 2 scenarios described at the beginning.
     * 2. The "keydown" listener is executed and the decision is made whether to show or hide the fake caret.
     * 3. If it should show up, the `widget-type-around` model selection attribute is set indicating
     *    on which side of the widget it should appear.
     * 4. The selection dispatcher reacts to the selection attribute and sets CSS classes responsible for the
     *    fake caret on the view widget.
     * 5. If the fake caret should disappear, the selection attribute is removed and the dispatcher
     *    does the CSS class clean-up in the view.
     * 6. Additionally, `change:range` and `FocusTracker#isFocused` listeners also remove the selection
     *    attribute (the former also removes widget CSS classes).
     *
     * @private
     */

  }, {
    key: "_enableTypeAroundFakeCaretActivationUsingKeyboardArrows",
    value: function _enableTypeAroundFakeCaretActivationUsingKeyboardArrows() {
      var _this3 = this;

      var editor = this.editor;
      var model = editor.model;
      var modelSelection = model.document.selection;
      var schema = model.schema;
      var editingView = editor.editing.view; // This is the main listener responsible for the fake caret.
      // Note: The priority must precede the default Widget class keydown handler ("high").

      this._listenToIfEnabled(editingView.document, 'arrowKey', function (evt, domEventData) {
        _this3._handleArrowKeyPress(evt, domEventData);
      }, {
        context: [isWidget, '$text'],
        priority: 'high'
      }); // This listener makes sure the widget type around selection attribute will be gone from the model
      // selection as soon as the model range changes. This attribute only makes sense when a widget is selected
      // (and the "fake horizontal caret" is visible) so whenever the range changes (e.g. selection moved somewhere else),
      // let's get rid of the attribute so that the selection downcast dispatcher isn't even bothered.


      this._listenToIfEnabled(modelSelection, 'change:range', function (evt, data) {
        // Do not reset the selection attribute when the change was indirect.
        if (!data.directChange) {
          return;
        } // Get rid of the widget type around attribute of the selection on every change:range.
        // If the range changes, it means for sure, the user is no longer in the active ("fake horizontal caret") mode.


        editor.model.change(function (writer) {
          writer.removeSelectionAttribute(TYPE_AROUND_SELECTION_ATTRIBUTE);
        });
      }); // Get rid of the widget type around attribute of the selection on every document change
      // that makes widget not selected any more (i.e. widget was removed).


      this._listenToIfEnabled(model.document, 'change:data', function () {
        var selectedModelElement = modelSelection.getSelectedElement();

        if (selectedModelElement) {
          var selectedViewElement = editor.editing.mapper.toViewElement(selectedModelElement);

          if (isTypeAroundWidget(selectedViewElement, selectedModelElement, schema)) {
            return;
          }
        }

        editor.model.change(function (writer) {
          writer.removeSelectionAttribute(TYPE_AROUND_SELECTION_ATTRIBUTE);
        });
      }); // React to changes of the model selection attribute made by the arrow keys listener.
      // If the block widget is selected and the attribute changes, downcast the attribute to special
      // CSS classes associated with the active ("fake horizontal caret") mode of the widget.


      this._listenToIfEnabled(editor.editing.downcastDispatcher, 'selection', function (evt, data, conversionApi) {
        var writer = conversionApi.writer;

        if (_this3._currentFakeCaretModelElement) {
          var _selectedViewElement = conversionApi.mapper.toViewElement(_this3._currentFakeCaretModelElement);

          if (_selectedViewElement) {
            // Get rid of CSS classes associated with the active ("fake horizontal caret") mode from the view widget.
            writer.removeClass(POSSIBLE_INSERTION_POSITIONS.map(positionToWidgetCssClass), _selectedViewElement);
            _this3._currentFakeCaretModelElement = null;
          }
        }

        var selectedModelElement = data.selection.getSelectedElement();

        if (!selectedModelElement) {
          return;
        }

        var selectedViewElement = conversionApi.mapper.toViewElement(selectedModelElement);

        if (!isTypeAroundWidget(selectedViewElement, selectedModelElement, schema)) {
          return;
        }

        var typeAroundFakeCaretPosition = getTypeAroundFakeCaretPosition(data.selection);

        if (!typeAroundFakeCaretPosition) {
          return;
        }

        writer.addClass(positionToWidgetCssClass(typeAroundFakeCaretPosition), selectedViewElement); // Remember the view widget that got the "fake-caret" CSS class. This class should be removed ASAP when the
        // selection changes

        _this3._currentFakeCaretModelElement = selectedModelElement;
      });

      this._listenToIfEnabled(editor.ui.focusTracker, 'change:isFocused', function (evt, name, isFocused) {
        if (!isFocused) {
          editor.model.change(function (writer) {
            writer.removeSelectionAttribute(TYPE_AROUND_SELECTION_ATTRIBUTE);
          });
        }
      });

      function positionToWidgetCssClass(position) {
        return "ck-widget_type-around_show-fake-caret_".concat(position);
      }
    }
    /**
     * A listener executed on each "keydown" in the view document, a part of
     * {@link #_enableTypeAroundFakeCaretActivationUsingKeyboardArrows}.
     *
     * It decides whether the arrow keypress should activate the fake caret or not (also whether it should
     * be deactivated).
     *
     * The fake caret activation is done by setting the `widget-type-around` model selection attribute
     * in this listener, and stopping and preventing the event that would normally be handled by the widget
     * plugin that is responsible for the regular keyboard navigation near/across all widgets (that
     * includes inline widgets, which are ignored by the widget type around plugin).
     *
     * @private
     */

  }, {
    key: "_handleArrowKeyPress",
    value: function _handleArrowKeyPress(evt, domEventData) {
      var editor = this.editor;
      var model = editor.model;
      var modelSelection = model.document.selection;
      var schema = model.schema;
      var editingView = editor.editing.view;
      var keyCode = domEventData.keyCode;
      var isForward = isForwardArrowKeyCode(keyCode, editor.locale.contentLanguageDirection);
      var selectedViewElement = editingView.document.selection.getSelectedElement();
      var selectedModelElement = editor.editing.mapper.toModelElement(selectedViewElement);
      var shouldStopAndPreventDefault; // Handle keyboard navigation when a type-around-compatible widget is currently selected.

      if (isTypeAroundWidget(selectedViewElement, selectedModelElement, schema)) {
        shouldStopAndPreventDefault = this._handleArrowKeyPressOnSelectedWidget(isForward);
      } // Handle keyboard arrow navigation when the selection is next to a type-around-compatible widget
      // and the widget is about to be selected.
      else if (modelSelection.isCollapsed) {
          shouldStopAndPreventDefault = this._handleArrowKeyPressWhenSelectionNextToAWidget(isForward);
        }

      if (shouldStopAndPreventDefault) {
        domEventData.preventDefault();
        evt.stop();
      }
    }
    /**
     * Handles the keyboard navigation on "keydown" when a widget is currently selected and activates or deactivates
     * the fake caret for that widget, depending on the current value of the `widget-type-around` model
     * selection attribute and the direction of the pressed arrow key.
     *
     * @private
     * @param {Boolean} isForward `true` when the pressed arrow key was responsible for the forward model selection movement
     * as in {@link module:utils/keyboard~isForwardArrowKeyCode}.
     * @returns {Boolean} Returns `true` when the keypress was handled and no other keydown listener of the editor should
     * process the event any further. Returns `false` otherwise.
     */

  }, {
    key: "_handleArrowKeyPressOnSelectedWidget",
    value: function _handleArrowKeyPressOnSelectedWidget(isForward) {
      var editor = this.editor;
      var model = editor.model;
      var modelSelection = model.document.selection;
      var typeAroundFakeCaretPosition = getTypeAroundFakeCaretPosition(modelSelection);
      return model.change(function (writer) {
        // If the fake caret is displayed...
        if (typeAroundFakeCaretPosition) {
          var isLeavingWidget = typeAroundFakeCaretPosition === (isForward ? 'after' : 'before'); // If the keyboard arrow works against the value of the selection attribute...
          // then remove the selection attribute but prevent default DOM actions
          // and do not let the Widget plugin listener move the selection. This brings
          // the widget back to the state, for instance, like if was selected using the mouse.
          //
          // **Note**: If leaving the widget when the fake caret is active, then the default
          // Widget handler will change the selection and, in turn, this will automatically discard
          // the selection attribute.

          if (!isLeavingWidget) {
            writer.removeSelectionAttribute(TYPE_AROUND_SELECTION_ATTRIBUTE);
            return true;
          }
        } // If the fake caret wasn't displayed, let's set it now according to the direction of the arrow
        // key press. This also means we cannot let the Widget plugin listener move the selection.
        else {
            writer.setSelectionAttribute(TYPE_AROUND_SELECTION_ATTRIBUTE, isForward ? 'after' : 'before');
            return true;
          }

        return false;
      });
    }
    /**
     * Handles the keyboard navigation on "keydown" when **no** widget is selected but the selection is **directly** next
     * to one and upon the fake caret should become active for this widget upon arrow keypress
     * (AKA entering/selecting the widget).
     *
     * **Note**: This code mirrors the implementation from the widget plugin but also adds the selection attribute.
     * Unfortunately, there is no safe way to let the widget plugin do the selection part first and then just set the
     * selection attribute here in the widget type around plugin. This is why this code must duplicate some from the widget plugin.
     *
     * @private
     * @param {Boolean} isForward `true` when the pressed arrow key was responsible for the forward model selection movement
     * as in {@link module:utils/keyboard~isForwardArrowKeyCode}.
     * @returns {Boolean} Returns `true` when the keypress was handled and no other keydown listener of the editor should
     * process the event any further. Returns `false` otherwise.
     */

  }, {
    key: "_handleArrowKeyPressWhenSelectionNextToAWidget",
    value: function _handleArrowKeyPressWhenSelectionNextToAWidget(isForward) {
      var editor = this.editor;
      var model = editor.model;
      var schema = model.schema;
      var widgetPlugin = editor.plugins.get('Widget'); // This is the widget the selection is about to be set on.

      var modelElementNextToSelection = widgetPlugin._getObjectElementNextToSelection(isForward);

      var viewElementNextToSelection = editor.editing.mapper.toViewElement(modelElementNextToSelection);

      if (isTypeAroundWidget(viewElementNextToSelection, modelElementNextToSelection, schema)) {
        model.change(function (writer) {
          widgetPlugin._setSelectionOverElement(modelElementNextToSelection);

          writer.setSelectionAttribute(TYPE_AROUND_SELECTION_ATTRIBUTE, isForward ? 'before' : 'after');
        }); // The change() block above does the same job as the Widget plugin. The event can
        // be safely canceled.

        return true;
      }

      return false;
    }
    /**
     * Registers a `mousedown` listener for the view document which intercepts events
     * coming from the widget type around UI, which happens when a user clicks one of the buttons
     * that insert a paragraph next to a widget.
     *
     * @private
     */

  }, {
    key: "_enableInsertingParagraphsOnButtonClick",
    value: function _enableInsertingParagraphsOnButtonClick() {
      var _this4 = this;

      var editor = this.editor;
      var editingView = editor.editing.view;

      this._listenToIfEnabled(editingView.document, 'mousedown', function (evt, domEventData) {
        var button = getClosestTypeAroundDomButton(domEventData.domTarget);

        if (!button) {
          return;
        }

        var buttonPosition = getTypeAroundButtonPosition(button);
        var widgetViewElement = getClosestWidgetViewElement(button, editingView.domConverter);
        var widgetModelElement = editor.editing.mapper.toModelElement(widgetViewElement);

        _this4._insertParagraph(widgetModelElement, buttonPosition);

        domEventData.preventDefault();
        evt.stop();
      });
    }
    /**
     * Creates the <kbd>Enter</kbd> key listener on the view document that allows the user to insert a paragraph
     * near the widget when either:
     *
     * * The fake caret was first activated using the arrow keys,
     * * The entire widget is selected in the model.
     *
     * In the first case, the new paragraph is inserted according to the `widget-type-around` selection
     * attribute (see {@link #_handleArrowKeyPress}).
     *
     * In the second case, the new paragraph is inserted based on whether a soft (<kbd>Shift</kbd>+<kbd>Enter</kbd>) keystroke
     * was pressed or not.
     *
     * @private
     */

  }, {
    key: "_enableInsertingParagraphsOnEnterKeypress",
    value: function _enableInsertingParagraphsOnEnterKeypress() {
      var _this5 = this;

      var editor = this.editor;
      var selection = editor.model.document.selection;
      var editingView = editor.editing.view;

      this._listenToIfEnabled(editingView.document, 'enter', function (evt, domEventData) {
        // This event could be triggered from inside the widget but we are interested
        // only when the widget is selected itself.
        if (evt.eventPhase != 'atTarget') {
          return;
        }

        var selectedModelElement = selection.getSelectedElement();
        var selectedViewElement = editor.editing.mapper.toViewElement(selectedModelElement);
        var schema = editor.model.schema;
        var wasHandled; // First check if the widget is selected and there's a type around selection attribute associated
        // with the fake caret that would tell where to insert a new paragraph.

        if (_this5._insertParagraphAccordingToFakeCaretPosition()) {
          wasHandled = true;
        } // Then, if there is no selection attribute associated with the fake caret, check if the widget
        // simply is selected and create a new paragraph according to the keystroke (Shift+)Enter.
        else if (isTypeAroundWidget(selectedViewElement, selectedModelElement, schema)) {
            _this5._insertParagraph(selectedModelElement, domEventData.isSoft ? 'before' : 'after');

            wasHandled = true;
          }

        if (wasHandled) {
          domEventData.preventDefault();
          evt.stop();
        }
      }, {
        context: isWidget
      });
    }
    /**
     * Similar to the {@link #_enableInsertingParagraphsOnEnterKeypress}, it allows the user
     * to insert a paragraph next to a widget when the fake caret was activated using arrow
     * keys but it responds to typing keystrokes instead of <kbd>Enter</kbd>.
     *
     * "Typing keystrokes" are keystrokes that insert new content into the document,
     * for instance, letters ("a") or numbers ("4"). The "keydown" listener enabled by this method
     * will insert a new paragraph according to the `widget-type-around` model selection attribute
     * as the user simply starts typing, which creates the impression that the fake caret
     * behaves like a real one rendered by the browser (AKA your text appears where the caret was).
     *
     * **Note**: At the moment this listener creates 2 undo steps: one for the `insertParagraph` command
     * and another one for actual typing. It is not a disaster but this may need to be fixed
     * sooner or later.
     *
     * Learn more in {@link module:typing/utils/injectunsafekeystrokeshandling}.
     *
     * @private
     */

  }, {
    key: "_enableInsertingParagraphsOnTypingKeystroke",
    value: function _enableInsertingParagraphsOnTypingKeystroke() {
      var _this6 = this;

      var editor = this.editor;
      var editingView = editor.editing.view;
      var keyCodesHandledSomewhereElse = [keyCodes.enter, keyCodes.delete, keyCodes.backspace]; // Note: The priority must precede the default observers.

      this._listenToIfEnabled(editingView.document, 'keydown', function (evt, domEventData) {
        // Don't handle enter/backspace/delete here. They are handled in dedicated listeners.
        if (!keyCodesHandledSomewhereElse.includes(domEventData.keyCode) && !isNonTypingKeystroke(domEventData)) {
          _this6._insertParagraphAccordingToFakeCaretPosition();
        }
      }, {
        priority: 'high'
      });
    }
    /**
     * It creates a "delete" event listener on the view document to handle cases when the <kbd>Delete</kbd> or <kbd>Backspace</kbd>
     * is pressed and the fake caret is currently active.
     *
     * The fake caret should create an illusion of a real browser caret so that when it appears before or after
     * a widget, pressing <kbd>Delete</kbd> or <kbd>Backspace</kbd> should remove a widget or delete the content
     * before or after a widget (depending on the content surrounding the widget).
     *
     * @private
     */

  }, {
    key: "_enableDeleteIntegration",
    value: function _enableDeleteIntegration() {
      var editor = this.editor;
      var editingView = editor.editing.view;
      var model = editor.model;
      var schema = model.schema;

      this._listenToIfEnabled(editingView.document, 'delete', function (evt, domEventData) {
        // This event could be triggered from inside the widget but we are interested
        // only when the widget is selected itself.
        if (evt.eventPhase != 'atTarget') {
          return;
        }

        var typeAroundFakeCaretPosition = getTypeAroundFakeCaretPosition(model.document.selection); // This listener handles only these cases when the fake caret is active.

        if (!typeAroundFakeCaretPosition) {
          return;
        }

        var direction = domEventData.direction;
        var selectedModelWidget = model.document.selection.getSelectedElement();
        var isFakeCaretBefore = typeAroundFakeCaretPosition === 'before';
        var isDeleteForward = direction == 'forward';
        var shouldDeleteEntireWidget = isFakeCaretBefore === isDeleteForward;

        if (shouldDeleteEntireWidget) {
          editor.execute('delete', {
            selection: model.createSelection(selectedModelWidget, 'on')
          });
        } else {
          var range = schema.getNearestSelectionRange(model.createPositionAt(selectedModelWidget, typeAroundFakeCaretPosition), direction); // If there is somewhere to move selection to, then there will be something to delete.

          if (range) {
            // If the range is NOT collapsed, then we know that the range contains an object (see getNearestSelectionRange() docs).
            if (!range.isCollapsed) {
              model.change(function (writer) {
                writer.setSelection(range);
                editor.execute(isDeleteForward ? 'deleteForward' : 'delete');
              });
            } else {
              var probe = model.createSelection(range.start);
              model.modifySelection(probe, {
                direction: direction
              }); // If the range is collapsed, let's see if a non-collapsed range exists that can could be deleted.
              // If such range exists, use the editor command because it it safe for collaboration (it merges where it can).

              if (!probe.focus.isEqual(range.start)) {
                model.change(function (writer) {
                  writer.setSelection(range);
                  editor.execute(isDeleteForward ? 'deleteForward' : 'delete');
                });
              } // If there is no non-collapsed range to be deleted then we are sure that there is an empty element
              // next to a widget that should be removed. "delete" and "deleteForward" commands cannot get rid of it
              // so calling Model#deleteContent here manually.
              else {
                  var deepestEmptyRangeAncestor = getDeepestEmptyElementAncestor(schema, range.start.parent);
                  model.deleteContent(model.createSelection(deepestEmptyRangeAncestor, 'on'), {
                    doNotAutoparagraph: true
                  });
                }
            }
          }
        } // If some content was deleted, don't let the handler from the Widget plugin kick in.
        // If nothing was deleted, then the default handler will have nothing to do anyway.


        domEventData.preventDefault();
        evt.stop();
      }, {
        context: isWidget
      });
    }
    /**
     * Attaches the {@link module:engine/model/model~Model#event:insertContent} event listener that, for instance, allows the user to paste
     * content near a widget when the fake caret is first activated using the arrow keys.
     *
     * The content is inserted according to the `widget-type-around` selection attribute (see {@link #_handleArrowKeyPress}).
     *
     * @private
     */

  }, {
    key: "_enableInsertContentIntegration",
    value: function _enableInsertContentIntegration() {
      var editor = this.editor;
      var model = this.editor.model;
      var documentSelection = model.document.selection;

      this._listenToIfEnabled(editor.model, 'insertContent', function (evt, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            content = _ref2[0],
            selectable = _ref2[1];

        if (selectable && !selectable.is('documentSelection')) {
          return;
        }

        var typeAroundFakeCaretPosition = getTypeAroundFakeCaretPosition(documentSelection);

        if (!typeAroundFakeCaretPosition) {
          return;
        }

        evt.stop();
        return model.change(function (writer) {
          var selectedElement = documentSelection.getSelectedElement();
          var position = model.createPositionAt(selectedElement, typeAroundFakeCaretPosition);
          var selection = writer.createSelection(position);
          var result = model.insertContent(content, selection);
          writer.setSelection(selection);
          return result;
        });
      }, {
        priority: 'high'
      });
    }
    /**
     * Attaches the {@link module:engine/model/model~Model#event:deleteContent} event listener to block the event when the fake
     * caret is active.
     *
     * This is required for cases that trigger {@link module:engine/model/model~Model#deleteContent `model.deleteContent()`}
     * before calling {@link module:engine/model/model~Model#insertContent `model.insertContent()`} like, for instance,
     * plain text pasting.
     *
     * @private
     */

  }, {
    key: "_enableDeleteContentIntegration",
    value: function _enableDeleteContentIntegration() {
      var editor = this.editor;
      var model = this.editor.model;
      var documentSelection = model.document.selection;

      this._listenToIfEnabled(editor.model, 'deleteContent', function (evt, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
            selection = _ref4[0];

        if (selection && !selection.is('documentSelection')) {
          return;
        }

        var typeAroundFakeCaretPosition = getTypeAroundFakeCaretPosition(documentSelection); // Disable removing the selection content while pasting plain text.

        if (typeAroundFakeCaretPosition) {
          evt.stop();
        }
      }, {
        priority: 'high'
      });
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'WidgetTypeAround';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [Enter, Delete];
    }
  }]);

  return WidgetTypeAround;
}(Plugin); // Injects the type around UI into a view widget instance.
//
// @param {module:engine/view/downcastwriter~DowncastWriter} viewWriter
// @param {Object.<String,String>} buttonTitles
// @param {module:engine/view/element~Element} widgetViewElement


export { WidgetTypeAround as default };

function injectUIIntoWidget(viewWriter, buttonTitles, widgetViewElement) {
  var typeAroundWrapper = viewWriter.createUIElement('div', {
    class: 'ck ck-reset_all ck-widget__type-around'
  }, function (domDocument) {
    var wrapperDomElement = this.toDomElement(domDocument);
    injectButtons(wrapperDomElement, buttonTitles);
    injectFakeCaret(wrapperDomElement);
    return wrapperDomElement;
  }); // Inject the type around wrapper into the widget's wrapper.

  viewWriter.insert(viewWriter.createPositionAt(widgetViewElement, 'end'), typeAroundWrapper);
} // FYI: Not using the IconView class because each instance would need to be destroyed to avoid memory leaks
// and it's pretty hard to figure out when a view (widget) is gone for good so it's cheaper to use raw
// <svg> here.
//
// @param {HTMLElement} wrapperDomElement
// @param {Object.<String,String>} buttonTitles


function injectButtons(wrapperDomElement, buttonTitles) {
  var _iterator2 = _createForOfIteratorHelper(POSSIBLE_INSERTION_POSITIONS),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var position = _step2.value;
      var buttonTemplate = new Template({
        tag: 'div',
        attributes: {
          class: ['ck', 'ck-widget__type-around__button', "ck-widget__type-around__button_".concat(position)],
          title: buttonTitles[position]
        },
        children: [wrapperDomElement.ownerDocument.importNode(RETURN_ARROW_ICON_ELEMENT, true)]
      });
      wrapperDomElement.appendChild(buttonTemplate.render());
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
} // @param {HTMLElement} wrapperDomElement


function injectFakeCaret(wrapperDomElement) {
  var caretTemplate = new Template({
    tag: 'div',
    attributes: {
      class: ['ck', 'ck-widget__type-around__fake-caret']
    }
  });
  wrapperDomElement.appendChild(caretTemplate.render());
} // Returns the ancestor of an element closest to the root which is empty. For instance,
// for `<baz>`:
//
//		<foo>abc<bar><baz></baz></bar></foo>
//
// it returns `<bar>`.
//
// @param {module:engine/model/schema~Schema} schema
// @param {module:engine/model/element~Element} element
// @returns {module:engine/model/element~Element|null}


function getDeepestEmptyElementAncestor(schema, element) {
  var deepestEmptyAncestor = element;

  var _iterator3 = _createForOfIteratorHelper(element.getAncestors({
    parentFirst: true
  })),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var ancestor = _step3.value;

      if (ancestor.childCount > 1 || schema.isLimit(ancestor)) {
        break;
      }

      deepestEmptyAncestor = ancestor;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return deepestEmptyAncestor;
}